export const convertHyphenZipcode = (code: string) => {
  let zip1 = code.slice(0, 3);
  let zip2 = code.slice(3, 7);
  return zip1 + '-' + zip2;
};
